import { render, staticRenderFns } from "./select-employee.vue?vue&type=template&id=56d67704&scoped=true"
import script from "./select-employee.vue?vue&type=script&lang=js"
export * from "./select-employee.vue?vue&type=script&lang=js"
import style0 from "./select-employee.vue?vue&type=style&index=0&id=56d67704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d67704",
  null
  
)

export default component.exports